/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_OpenInputs */

const id_tld_pricing_open = /** @type {(inputs: Tld_Pricing_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const en_tld_pricing_open = /** @type {(inputs: Tld_Pricing_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Tld_Pricing_OpenInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_open = /** @type {((inputs?: Tld_Pricing_OpenInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_OpenInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_open(inputs)
	return id_tld_pricing_open(inputs)
});